import { Map } from 'immutable';
import { cookiesHelper } from '@saucelabs/sl-util-helpers';
import { types as authTypes } from '@saucelabs/sl-container-authentication';

import * as types from './types';

import { getCookieDomain } from '@saucelabs/web-ui-auth/src/ducks/container/operations';

const initialState = Map({
  isUnverifiedAlertDismissed: false,
  expiredTrialModalDismissed: false,
  initialized: false,
  unauthenticated: false,
  errorCode: undefined,
  cordToken: undefined,
  // Growth user attributes
  userAttributes: undefined,
});

const IS_LOGGED_IN_COOKIE = 'sll';

const appReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.DISMISS_UNVERIFIED_ALERT:
      return state.set('isUnverifiedAlertDismissed', true);
    case types.DISMISS_EXPIRED_TRIAL_MODAL:
      return state.set('expiredTrialModalDismissed', true);
    case types.GET_CORD_TOKEN.SUCCESS:
      return state.set('cordToken', payload.authToken);
    case types.GET_USER_ATTRIBUTES.SUCCESS:
      return state.set('userAttributes', payload);
    case types.INITIALIZED:
      // set a cookie to indicate that a user is logged in
      cookiesHelper.setItem(IS_LOGGED_IN_COOKIE, 'true', Infinity, '/', getCookieDomain(), false);
      return state.set('initialized', true);
    case authTypes.LOGOUT.SUCCESS:
      cookiesHelper.removeItem(IS_LOGGED_IN_COOKIE, '/', getCookieDomain());
      return state.set('unauthenticated', true);
    case authTypes.ME_USERSERVICE_GET.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('unauthenticated', true)
          .set('errorCode', payload?.response?.status);
      });
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default appReducer;
export { initialState };
